import FiberBendingCalculator from './components/bending_calculator'
import FiberTensionCalculator from './components/tension_calculator'
import FiberStressCalculator from './components/stress_calculator'

function App() {
  return (
    <main className="flex flex-col gap-10 font-body">     
      <FiberBendingCalculator />
      <FiberTensionCalculator />
      <FiberStressCalculator />
    </main>
  )
}

export default App
